<template>
  <transition name="showhelp" @after-enter="afterEnter">
    <div
      v-if="show"
      :id="id ? id + '-help-panel' : null"
      ref="mainPanel"
      class="cat-help-panel help-panel opened open"
      role="dialog"
      :aria-label="panelCaption"
      :data-label="panelCaption"
      @keydown.esc="closeHelp"
      @keydown.tab="setFocus"
    >
      <div class="help-content">
        <div class="handle clearfix">
          <cat-btn
            small
            icon="cancel"
            class="close-panel right"
            :label="showCloseText ? panelCloseText : null"
            :hint="showCloseText ? null : panelCloseText"
            @ui-click="closeHelp"
          ></cat-btn>
        </div>
        <!-- cms content -->
        <div class="help-frame">
          <slot></slot>
          <cat-iframe
            v-if="url && url.length > 0"
            ref="iframe"
            :url="url"
            style="height: 100%"
            :frame-id="id ? id + '-help-content' : 'help-content'"
            class-name="help-panel-iframe"
            @ui-loaded="frameLoaded"
          ></cat-iframe>
        </div>
        <!-- eof cms -->
        <div ref="panelEnd" tabindex="0" @focus="setFocus"></div>
      </div>
      <span class="tip"></span>
    </div>
  </transition>
</template>
<script lang="ts">
import { defineComponent, inject } from "vue";
import { defaultResolveTxt } from "@/components/field-element";
import CatBtn from "@/components/catBtn/catBtn.vue";
import CatIframe from "@/components/catIFrame/catIFrame.vue";

export default defineComponent({
  setup() {
    // Inject the global value
    const resolveTxt = inject("resolveTxt", defaultResolveTxt);

    return {
      resolveTxt
    };
  },

  name: "CatHelpPanel",
  components: { CatBtn, CatIframe },
  url: String,
  props: {
    id: {
      type: [String, Number],
      description: "The value will be appended with '-help-panel'."
    },
    open: {
      type: Boolean,
      description: "Indicates if the panel is displayed."
    },
    panelTitle: {
      type: String,
      description:
        "Accessible name of this help content group. Default text key is skin.help.panel.caption if not present or 'Page Help'."
    },
    closeText: {
      type: String,
      description:
        "Label of the panel close button. Default text key is skin.help.panel.close if not present or 'Close'."
    },
    showCloseText: {
      type: Boolean,
      default: false,
      description:
        "No close text is displayed by default. Only the cancel icon and hint text. If showing text no hint text is displayed."
    },
    url: {
      type: String,
      description: "External help content URL."
    }
  },
  data: function () {
    return {
      show: this.open,
      mainEl: undefined as any
    };
  },
  computed: {
    panelCaption: function () {
      return this.panelTitle
        ? this.panelTitle
        : this.resolveTxt("skin.help.panel.caption", "Page help");
    },
    panelCloseText: function () {
      return this.closeText
        ? this.closeText
        : this.resolveTxt("skin.help.panel.close", "Close");
    }
  },
  watch: {
    open: function (newval, oldval) {
      let t = this;
      this.show = newval;
      if (this.show) {
        this.$nextTick(function () {
          t.mainEl = t.$refs.mainPanel;
        });
      }
    }
  },
  mounted: function () {
    var t = this;

    document.addEventListener("ui-background-click.help", function (evt) {
      t.eventHandler();
    });
  },

  beforeUnmount: function () {
    document.removeEventListener("ui-background-click.help", this.eventHandler);
  },
  methods: {
    iframeAddEventHandler: function () {
      var iframe = globalThis.jQuery("iframe", this.mainEl);
      if (iframe.length > 0) {
        var _t = this;
        if (iframe.get(0).contentDocument) {
          globalThis
            .jQuery("body", iframe.get(0).contentDocument)
            .on("keydown", function (event) {
              // Tab key
              if (event.key === "Tab" || event.keyCode === 9) {
                _t.setFocus(event);
                event.stopPropagation();
              }
            });
        }
      }
    },
    closeHelp: function () {
      this.$emit("ui-close", {
        value: this.show
      });
      this.show = false;
    },
    afterEnter: function () {
      globalThis
        .jQuery(this.mainEl)
        .draggable({ containment: "window", handle: ".handle" })
        .resizable()
        .css({});

      // Set the initial focus to the panel (dialog pattern)
      globalThis.jQuery(".close-panel", this.mainEl).first().trigger("focus");

      // Need to add event handlers to the iframe.
      //this.iframeAddEventHandler();
    },
    setFocus: function (event) {
      // First item is the close button, last item empty div
      var firstItem = globalThis.jQuery(".close-panel", this.mainEl).first();
      var lastItem = globalThis.jQuery(":tabbable", this.mainEl).last();

      // // Last item is in the iframe contents
      // var iframe = globalThis.jQuery("iframe", this.$el);
      // if (iframe.length > 0) {
      //   lastItem = iframe.first().contents().find(":tabbable").last();
      // }
      var target = globalThis.jQuery(event.target).first();

      // If the tab event is fired from the first or the last item in the modal,
      // trap the focus inside the modal
      if (firstItem.is(lastItem)) {
        event.preventDefault();
        firstItem.focus();
      } else if (target.is(firstItem)) {
        // Tabbing to previous, focus to the last
        if (event.shiftKey) {
          event.preventDefault();
          lastItem.trigger("focus");
        }
      } else if (target.is(lastItem)) {
        // Received focus event and coming from the first target means tabbing backwards (shift key) do not
        if (event.type === "focus") {
          event.preventDefault();
          if (firstItem.is(event.relatedTarget)) {
            lastItem.trigger("keydown", {
              which: 9,
              keyCode: 9,
              code: "Tab",
              key: "Tab",
              shiftKey: true
            });
          } else {
            firstItem.focus();
          }
        } else {
          if (!event.shiftKey) {
            event.preventDefault();
            firstItem.focus();
          }
        }
      }
    },
    eventHandler: function () {
      if (this.show) {
        this.closeHelp();
      }
    },
    frameLoaded: function (e) {
      var evt = new CustomEvent("ui-unblock", {});
      document.dispatchEvent(evt);
      // globalThis.jQuery(this.$refs.close).focus()
    }
  }
});
</script>
